import {
  BellOutlined,
  QuestionCircleOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import { SelectLang as UmiSelectLang } from '@umijs/max';

export type SiderTheme = 'light' | 'dark';

export const SelectLang: React.FC = () => {
  return (
    <UmiSelectLang
      style={{
        padding: 4,
      }}
    />
  );
};

export const SettingAction: React.FC = () => {
  return (
    <a
      href="#settings"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '32px',
        height: '32px',
        borderRadius: '50%',
        border: '1px solid rgba(0, 0, 0, 0.1)',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
        fontSize: '14px',
        color: 'inherit',
        background: '#fff',
        transition: 'all 0.3s',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.2)';
        e.currentTarget.style.transform = 'translateY(-2px)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.15)';
        e.currentTarget.style.transform = 'translateY(0)';
      }}
    >
      <SettingOutlined />
    </a>
  );
};

export const NoticeAction: React.FC = () => {
  return (
    <a
      href="#notice"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        textDecoration: 'none',
        color: 'inherit',
        transition: 'all 0.3s',
      }}
      onMouseEnter={(e) => {
        const iconElement = e.currentTarget.querySelector(
          '.notice-icon',
        ) as HTMLElement;
        if (iconElement) {
          iconElement.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.2)';
          iconElement.style.transform = 'translateY(-2px)';
        }
      }}
      onMouseLeave={(e) => {
        const iconElement = e.currentTarget.querySelector(
          '.notice-icon',
        ) as HTMLElement;
        if (iconElement) {
          iconElement.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.15)';
          iconElement.style.transform = 'translateY(0)';
        }
      }}
    >
      <span
        className="notice-icon"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '32px',
          height: '32px',
          borderRadius: '50%',
          border: '1px solid rgba(0, 0, 0, 0.1)',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
          fontSize: '14px',
          color: 'inherit',
          background: '#fff',
          transition: 'all 0.3s',
        }}
      >
        <BellOutlined />
      </span>
      <span style={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.65)' }}>
        系统通知
      </span>
    </a>
  );
};

export const Question: React.FC = () => {
  return (
    <a
      href="https://pro.ant.design/docs/getting-started"
      target="_blank"
      rel="noreferrer"
      style={{
        display: 'inline-flex',
        padding: '4px',
        fontSize: '18px',
        color: 'inherit',
      }}
    >
      <QuestionCircleOutlined />
    </a>
  );
};
